module.exports = __webpack_public_path__ + "img/ski_suit.c9a89176.png";